import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12.4,
	height: 24,
	viewBox: "0 0 12.4 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "#000",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M.8.8l10.7 10.7c.1.1.1.2.2.2 0 .1.1.2.1.3s0 .2-.1.3c0 .1-.1.2-.2.2L.8 23.2"
	})]
});
const ForwardRef = forwardRef(SvgArrowRight2);
export default ForwardRef;
